import React from "react";
import { cn } from "../utils/cn";

export default function Modal({ isOpen, onClose, children, width = "50%" }) {
    if (!isOpen) return null;

    // Handle different width values
    const modalWidth = width === "auto" ? "auto" : width;

    return (
        <div className="fixed inset-0 z-[999] bg-black/60 flex items-center justify-center">
            <div
                className="bg-white rounded-lg p-8 relative overflow-auto max-h-[90vh]"
                style={{ width: modalWidth, maxWidth: "90%" }}
            >
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-black hover:text-gray-700 transition-colors z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer"
                    aria-label="Close"
                >
                    ✕
                </button>
                {children}
            </div>
        </div>
    );
}
